module.exports = __webpack_public_path__ + "static/img/logo.dde0e60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contactus/logo.png
// module id = qTY6
// module chunks = 51